// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","524":"app","933":"auth"}[chunkId] || chunkId) + "." + {"85":"b32d9185","431":"38b47326","523":"1ffe7e97","524":"369597a3","830":"169511c7","933":"669cd14c"}[chunkId] + ".chunk.js";
};